/**
 * batchesApi.js
 * -------------
 * API client for Batches Master using createMasterApiClient.
 * Connects directly to FastAPI backend /batches/ endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

const batchesClient = createMasterApiClient('batches');

export async function listBatches(params = {}) {
  return await batchesClient.list(params);
}

export async function getBatchDetail(batchId) {
  return await batchesClient.getById(batchId);
}

export async function createBatch(payload) {
  return await batchesClient.create(payload);
}

export async function updateBatch(batchId, payload) {
  return await batchesClient.update(batchId, payload);
}

export async function archiveBatch(batchId) {
  return await batchesClient.archive(batchId);
}

export async function deleteBatch(batchId) {
  return await batchesClient.remove(batchId);
}

export async function getBatchOptions() {
  return await batchesClient.getDropdownOptions();
}
